import React, { useState, useEffect } from 'react';
import { useNotifications } from '../../context/NotificationContext';
import FeedbackModal from '../utp/FeedbackModal';
import TicketModal from '../master/TicketModal';
import { authHeaders } from '../../api';
import { ENDPOINTS } from '../../endpoints';

const GlobalNotificationModal = () => {
  const { activeEntity, closeEntity } = useNotifications();
  const [ticketData, setTicketData] = useState(null);

  useEffect(() => {
    if (activeEntity?.type === 'ticket' && activeEntity.id) {
      // Cargar datos del ticket desde el listado propio del usuario
      fetch(ENDPOINTS.TICKETS_MINE, { headers: authHeaders() })
        .then(r => r.ok ? r.json() : [])
        .then(tickets => {
          const t = tickets.find(tk => tk.ticket_id === activeEntity.id);
          setTicketData(t || null);
        })
        .catch(() => setTicketData(null));
    } else {
      setTicketData(null);
    }
  }, [activeEntity]);

  if (!activeEntity) return null;

  if (activeEntity.type === 'planned_class') {
    return (
      <FeedbackModal
        show={true}
        plannedClassId={activeEntity.id}
        handleClose={closeEntity}
      />
    );
  }

  if (activeEntity.type === 'ticket') {
    return (
      <TicketModal
        show={true}
        onHide={closeEntity}
        ticket={ticketData}
        onUpdated={() => {}}
      />
    );
  }

  return null;
};

export default GlobalNotificationModal;
